import { useMemo } from "react";
import { SingletonRouter } from "next/router";

import { useRouter } from "../../../../../lib/routerContext";
import { CardOrientationDefault, CardOrientationQueryParam, Orientation } from "./constants";
import { RouteParams } from "./types";

type GetCardOrientation = (r?: SingletonRouter<RouteParams>) => Orientation;
const getCardOrientation: GetCardOrientation = router => {
  const orientation = router && router.query && router.query[CardOrientationQueryParam];
  return orientation || CardOrientationDefault;
};

type UseCardOrientation = () => Orientation;
const useCardOrientation: UseCardOrientation = () => {
  const router = useRouter<RouteParams>();
  return useMemo(() => getCardOrientation(router), [router]);
};

export { useCardOrientation };
